import { render, staticRenderFns } from "./agreementList.vue?vue&type=template&id=04dfdcec"
import script from "./agreementList.vue?vue&type=script&lang=js"
export * from "./agreementList.vue?vue&type=script&lang=js"
import style0 from "./agreementList.vue?vue&type=style&index=0&id=04dfdcec&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports